export enum ERoutes {
  Activity = "/activity",
  Analytics = "/analytics",
  Retail = "/retail",
  Wholesale = "/wholesale",
  Products = "/products",
  Distributors = "/distributors",
  Purchase = "/purchase",
  Inventory = "/inventory",
  CustomOrder = "/custom-order",
}
